export default function(input) {
  /*
   * The first part of this regex in from this post:
   * https://stackoverflow.com/questions/4460586/javascript-regular-expression-to-check-for-ip-addresses
   * and the last part is for ip/network
   * */
  const validator = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\/\d+)?$/;
  return validator.test(input);
}
